var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0.625H2.625C1.6625 0.625 0.875 1.4125 0.875 2.375V14.625C0.875 15.5875 1.6625 16.375 2.625 16.375H18.375C19.3375 16.375 20.125 15.5875 20.125 14.625V2.375C20.125 1.4125 19.3375 0.625 18.375 0.625ZM9.625 7.625H3.5C3.01875 7.625 2.625 7.23125 2.625 6.75C2.625 6.26875 3.01875 5.875 3.5 5.875H9.625C10.1062 5.875 10.5 6.26875 10.5 6.75C10.5 7.23125 10.1062 7.625 9.625 7.625ZM9.625 4.125H3.5C3.01875 4.125 2.625 3.73125 2.625 3.25C2.625 2.76875 3.01875 2.375 3.5 2.375H9.625C10.1062 2.375 10.5 2.76875 10.5 3.25C10.5 3.73125 10.1062 4.125 9.625 4.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.0e21dfc8.svg";
export { ForwardRef as ReactComponent };